import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useRef } from "react";
import { InputNumber } from "antd";
import { Utils } from "@react-awesome-query-builder/ui";
var _Utils$NumberFormat = Utils.NumberFormat,
  getNumberFormatProps = _Utils$NumberFormat.getNumberFormatProps,
  numericFormatter = _Utils$NumberFormat.numericFormatter,
  numericParser = _Utils$NumberFormat.numericParser,
  addLeadingZeros = _Utils$NumberFormat.addLeadingZeros,
  addTrailingZeros = _Utils$NumberFormat.addTrailingZeros;
export default (function (props) {
  var value = props.value,
    setValue = props.setValue,
    readonly = props.readonly,
    placeholder = props.placeholder,
    config = props.config,
    min = props.min,
    max = props.max,
    step = props.step,
    customProps = props.customProps,
    prefix = props.prefix,
    suffix = props.suffix;
  var numericFormatProps = _objectSpread(_objectSpread({}, getNumberFormatProps(props, ["prefix", "suffix"])), {}, {
    min: min,
    max: max
  });
  var numericFormatPropsJson = JSON.stringify(numericFormatProps);
  var renderSize = config.settings.renderSize;
  var aValue = value != undefined ? value : undefined;
  var lastValueRef = useRef(undefined);
  var extFormatter = useCallback(function (numOrStr) {
    var _lastValueRef$current;
    var num = parseFloat(numOrStr);
    var prev = lastValueRef.current;
    var extraLeadingZeros, trailingZeros;
    var str = numericFormatter(numOrStr, numericFormatProps);
    if ((prev === null || prev === void 0 ? void 0 : prev.num) === num) {
      if (prev !== null && prev !== void 0 && prev.extraLeadingZeros) {
        // Just to keep zeros in case of `allowLeadingZeros: true`
        extraLeadingZeros = prev.extraLeadingZeros;
        str = addLeadingZeros(str, extraLeadingZeros);
      }
      if (prev !== null && prev !== void 0 && prev.trailingZeros) {
        // To prevent `1.009` -> `1` (should be `1.00`) after removing "9"
        trailingZeros = prev.trailingZeros;
        str = addTrailingZeros(str, trailingZeros);
      }
    }
    if (str !== ((_lastValueRef$current = lastValueRef.current) === null || _lastValueRef$current === void 0 ? void 0 : _lastValueRef$current.str)) {
      lastValueRef.current = {
        num: num,
        str: str,
        extraLeadingZeros: extraLeadingZeros,
        trailingZeros: trailingZeros
      };
    }
    return str;
  }, [numericFormatPropsJson]);
  var extParser = useCallback(function (str) {
    var prev = lastValueRef.current;
    var prevStr = prev === null || prev === void 0 ? void 0 : prev.str;
    var prevNum = prev === null || prev === void 0 ? void 0 : prev.num;
    var res = numericParser(str, numericFormatProps, prevStr, prevNum);
    if (str !== prevStr) {
      lastValueRef.current = res;
    }
    return res.num;
  }, [numericFormatPropsJson]);
  var handleChange = useCallback(function (val) {
    if (val === "" || val === null) val = undefined;
    setValue(val);
  }, [setValue]);
  return /*#__PURE__*/React.createElement(InputNumber, _extends({
    formatter: extFormatter,
    parser: extParser,
    size: renderSize,
    value: aValue,
    placeholder: placeholder,
    disabled: readonly,
    onChange: handleChange,
    min: min,
    max: max,
    step: step,
    prefix: prefix,
    suffix: suffix,
    style: {
      width: "150px"
    }
  }, customProps));
});